// Static data for candidates with comprehensive information
export const candidatesData = [
  {
    id: 1,
    // Data Pribadi
    personalData: {
      full_name: "Budi Santoso",
      gender: "Male",
      birth_place: "Jakarta",
      birth_date: "1995-03-12",
      religion: "Islam",
      ethnicity: "Jawa",
      age: 30,
      height_cm: 172,
      weight_kg: 68,
      address: "Jl. Merdeka No.1 Jakarta",
      phone: "081234567890",
      id_number: "3173xxxxxxxxxxxx",
      id_region: "DKI Jakarta",
      living_status: "Parents",
      vehicle_type: "Motorcycle",
      vehicle_ownership: "Own",
      best_achievement: "Juara 1 Lomba Matematika",
      best_achievement_desc: "Menang olimpiade tingkat provinsi",
      worst_achievement: "Nilai Seni Terendah",
      worst_achievement_desc: "Kurang minat di seni rupa",
      language_active: "Indonesia; English",
      language_passive: "Japanese",
      education_sponsor: "Orang Tua",
      scholarship: "Beasiswa Pemprov",
      scholarship_duration: "2 tahun",
      scholarship_desc: "Biaya UKT ditanggung",
      influence_source: "Family",
      influence_note: "Orang tua menyarankan kuliah TI",
      publication: "Skripsi: Optimasi Rute Kurir",
      highschool_avg_score: 82.50,
      highschool_subject_count: 12,
      gpa: 3.60,
      gpa_max: 4.00,
      photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face"
    },
    
    // Riwayat
    history: {
      last_job_reason_leave: "Ingin tantangan baru",
      last_job_salary: "8.000.000",
      last_job_benefits: "BPJS; Meal; Transport",
      job_most_liked: "Problem solving",
      job_least_liked: "Pekerjaan repetitif",
      hobby: "Fotografi, bersepeda",
      sport: 1,
      sport_desc: "Futsal mingguan",
      free_time: "Belajar online",
      reading_hours: "1-3h",
      reading_topics: "Teknologi; Logistik",
      newspaper: "Kompas",
      magazine: "SWI"
    },
    
    // Riwayat Pekerjaan
    workHistory: [
      {
        masuk: "2020-01-15",
        keluar: "2023-12-31", 
        jabatan: "Senior Software Engineer",
        perusahaan: "PT. Tech Solutions",
        alamat_telp: "Jl. Sudirman No.50, Jakarta - 021-5551234",
        keterangan: "Mengembangkan aplikasi web menggunakan React dan Node.js"
      },
      {
        masuk: "2018-06-01",
        keluar: "2019-12-31",
        jabatan: "Frontend Developer", 
        perusahaan: "CV. Digital Inovasi",
        alamat_telp: "Jl. Thamrin No.25, Jakarta - 021-5554321",
        keterangan: "Membuat interface website responsif"
      }
    ],
    
    // Aktivitas Sosial
    socialActivities: [
      {
        tahun: "2022",
        jenis_aktivitas: "Volunteer Teaching",
        jabatan: "Koordinator",
        organisasi: "Komunitas Belajar Jakarta"
      },
      {
        tahun: "2021",
        jenis_aktivitas: "Environmental Campaign",
        jabatan: "Member",
        organisasi: "Green Jakarta Movement"
      }
    ],
    
    // Keluarga
    family: {
      marital_status: "Single",
      marriage_date: "",
      marriage_count: 0,
      members: [
        {
          jenis: "Ayah",
          nama: "Santoso Wijaya",
          gender: "L",
          usia: 55,
          pendidikan_terakhir: "S1",
          jabatan: "Manager",
          pekerjaan: "Pegawai Swasta",
          perusahaan: "PT. Maju Jaya",
          keterangan: "Masih aktif bekerja"
        },
        {
          jenis: "Ibu", 
          nama: "Siti Aminah",
          gender: "P",
          usia: 52,
          pendidikan_terakhir: "SMA",
          jabatan: "-",
          pekerjaan: "Ibu Rumah Tangga",
          perusahaan: "-",
          keterangan: "Mengurus rumah tangga"
        }
      ]
    },
    
    // Lamaran dan Keterampilan
    applicationSkills: {
      apply_reason: "Ingin berkarier di logistik tech",
      apply_initiator: "Parents",
      apply_initiator_note: "Direkomendasikan ayah",
      desired_position: "Backend Developer",
      expected_salary: "10.000.000",
      expected_benefits: "Asuransi; Transport",
      skills: "Node.js; MySQL; GCP",
      willing_medical: 1,
      willing_psychology: 1,
      willing_relocate: 1,
      willing_trial: 1,
      willing_transfer: 1,
      willing_rules: 1,
      computer_skill: 1,
      computer_programs: "VS Code; Docker; Git",
      typing_level: "Fluent",
      driving_ability: "Motor; Mobil",
      vehicle_knowledge: 1
    },
    
    // Pendidikan Formal
    education: [
      {
        jenjang: "S1",
        nama_sekolah: "Universitas Indonesia",
        tempat: "Jakarta",
        tahun_lulus: "2017",
        rata_rata_nilai: "3.60",
        jurusan: "Teknik Informatika"
      },
      {
        jenjang: "SMA",
        nama_sekolah: "SMA Negeri 1 Jakarta", 
        tempat: "Jakarta",
        tahun_lulus: "2013",
        rata_rata_nilai: "82.50",
        jurusan: "IPA"
      }
    ],
    
    // Kursus
    courses: [
      {
        instruktur_lembaga: "Google Cloud Training",
        tempat: "Online",
        lama_pendidikan: "3 bulan",
        yang_membiayai: "Pribadi",
        keterangan: "Cloud Architecture Certification"
      },
      {
        instruktur_lembaga: "Dicoding Indonesia",
        tempat: "Online", 
        lama_pendidikan: "6 bulan",
        yang_membiayai: "Beasiswa",
        keterangan: "Full Stack Web Development"
      }
    ],
    
    // Umum & Kesehatan
    generalHealth: {
      willing_original_certificate: 1,
      allow_contact_employer: 1,
      ever_fired: 0,
      decision_advice_source: "Boss",
      decision_advice_note: "Diskusi dengan atasan",
      personal_advice_source: "Keluarga",
      personal_advice_note: "Diskusi dengan orang tua",
      reaction_to_criticism: "Menerima dan memperbaiki",
      common_illness: "Flu ringan",
      serious_illness: 0,
      serious_illness_desc: "",
      eye_disease: 0,
      lung_disease: 0,
      ear_disease: 0,
      diabetes: 0,
      hypertension: 0,
      heart_disease: 0,
      last_checkup: "2025-01-10",
      strength: "Cepat belajar",
      weakness: "Kurang teliti jika terburu-buru"
    },
    
    // Lain-lain
    others: {
      // Relasi saat berhalangan
      emergency_relations: [
        {
          nama: "Santoso Wijaya",
          usia: 55,
          alamat: "Jl. Merdeka No.1 Jakarta",
          no_telepon: "081234567890",
          hubungan: "Ayah",
          keterangan: "Kontak utama"
        }
      ],
      
      // Eks atasan/keluarga
      former_relations: [
        {
          nama: "Dr. Budi Santoso",
          usia: 45,
          alamat: "PT. Tech Solutions, Jl. Sudirman No.50 Jakarta",
          no_telepon: "081111222333",
          hubungan: "Mantan Atasan",
          keterangan: "CTO PT. Tech Solutions"
        }
      ],
      
      // Penjamin di PT Eureka
      guarantors: [
        {
          nama: "Ahmad Wijaya",
          usia: 40,
          alamat: "PT. Eureka Group, Jl. Gatot Subroto Jakarta",
          no_telepon: "081999888777",
          hubungan: "Teman",
          keterangan: "Senior Developer di PT. Eureka"
        }
      ]
    },
    
    applicationStatus: "Active",
    applicationDate: "2024-01-15",
    interviewDate: "2024-01-25",
    interviewStatus: "Scheduled"
  },
  {
    id: 2,
    // Data Pribadi
    personalData: {
      full_name: "Sari Dewi Lestari",
      gender: "Female",
      birth_place: "Bandung",
      birth_date: "1992-08-22",
      religion: "Kristen",
      ethnicity: "Sunda",
      age: 32,
      height_cm: 165,
      weight_kg: 55,
      address: "Jl. Dago No. 45, Bandung",
      phone: "082345678901",
      id_number: "3273086208920002",
      id_region: "Jawa Barat",
      living_status: "Independent",
      vehicle_type: "Car",
      vehicle_ownership: "Own",
      best_achievement: "Best Marketing Campaign 2022",
      best_achievement_desc: "Meningkatkan sales 150% dalam 6 bulan",
      worst_achievement: "Gagal Target Q1 2020",
      worst_achievement_desc: "Tidak mencapai target karena pandemi",
      language_active: "Indonesia; English; Sunda",
      language_passive: "Japanese",
      education_sponsor: "Orang Tua",
      scholarship: "Beasiswa Prestasi",
      scholarship_duration: "4 tahun",
      scholarship_desc: "Full scholarship S1",
      influence_source: "Self",
      influence_note: "Minat pribadi di bidang marketing",
      publication: "Artikel: Digital Marketing Trends 2023",
      highschool_avg_score: 88.75,
      highschool_subject_count: 12,
      gpa: 3.65,
      gpa_max: 4.00,
      photo: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face"
    },
    
    // Riwayat
    history: {
      last_job_reason_leave: "Ingin bergabung dengan perusahaan yang lebih besar",
      last_job_salary: "12.000.000",
      last_job_benefits: "BPJS; Meal; Transport; Bonus",
      job_most_liked: "Creative campaigns",
      job_least_liked: "Administrative tasks",
      hobby: "Photography, traveling, cooking",
      sport: 1,
      sport_desc: "Yoga 3x seminggu",
      free_time: "Reading marketing books",
      reading_hours: "2-4h",
      reading_topics: "Marketing; Business; Psychology",
      newspaper: "Kompas",
      magazine: "Marketing Mix"
    },
    
    // Riwayat Pekerjaan
    workHistory: [
      {
        masuk: "2019-03-01",
        keluar: "2023-11-30", 
        jabatan: "Digital Marketing Manager",
        perusahaan: "PT. Marketing Pro",
        alamat_telp: "Jl. Asia Afrika No.100, Bandung - 022-4441234",
        keterangan: "Mengelola strategi digital marketing dan social media"
      },
      {
        masuk: "2017-07-15",
        keluar: "2019-02-28",
        jabatan: "Marketing Specialist", 
        perusahaan: "Startup Creative",
        alamat_telp: "Jl. Braga No.75, Bandung - 022-4445678",
        keterangan: "Mengembangkan kampanye marketing online"
      }
    ],
    
    // Aktivitas Sosial
    socialActivities: [
      {
        tahun: "2023",
        jenis_aktivitas: "Digital Marketing Workshop",
        jabatan: "Trainer",
        organisasi: "Komunitas Marketer Bandung"
      },
      {
        tahun: "2022",
        jenis_aktivitas: "Women Empowerment",
        jabatan: "Volunteer",
        organisasi: "Kartini Foundation"
      }
    ],
    
    // Keluarga
    family: {
      marital_status: "Single",
      marriage_date: "",
      marriage_count: 0,
      members: [
        {
          jenis: "Ayah",
          nama: "Agus Lestari",
          gender: "L",
          usia: 58,
          pendidikan_terakhir: "S1",
          jabatan: "Owner",
          pekerjaan: "Wiraswasta",
          perusahaan: "Toko Elektronik Agus",
          keterangan: "Bisnis keluarga"
        },
        {
          jenis: "Ibu", 
          nama: "Rina Sari",
          gender: "P",
          usia: 55,
          pendidikan_terakhir: "S1",
          jabatan: "Guru",
          pekerjaan: "Guru SD",
          perusahaan: "SD Negeri 5 Bandung",
          keterangan: "PNS aktif"
        }
      ]
    },
    
    // Lamaran dan Keterampilan
    applicationSkills: {
      apply_reason: "Ingin mengembangkan karir di perusahaan teknologi",
      apply_initiator: "Self",
      apply_initiator_note: "Inisiatif pribadi setelah riset perusahaan",
      desired_position: "Marketing Manager",
      expected_salary: "15.000.000",
      expected_benefits: "Asuransi; Transport; Bonus Performance",
      skills: "Digital Marketing; Social Media; Google Ads; SEO; Analytics",
      willing_medical: 1,
      willing_psychology: 1,
      willing_relocate: 1,
      willing_trial: 1,
      willing_transfer: 1,
      willing_rules: 1,
      computer_skill: 1,
      computer_programs: "Adobe Creative Suite; Google Analytics; Canva",
      typing_level: "Expert",
      driving_ability: "Mobil",
      vehicle_knowledge: 0
    },
    
    // Pendidikan Formal
    education: [
      {
        jenjang: "S1",
        nama_sekolah: "Institut Teknologi Bandung",
        tempat: "Bandung",
        tahun_lulus: "2015",
        rata_rata_nilai: "3.65",
        jurusan: "Manajemen"
      },
      {
        jenjang: "SMA",
        nama_sekolah: "SMA Negeri 3 Bandung", 
        tempat: "Bandung",
        tahun_lulus: "2011",
        rata_rata_nilai: "88.75",
        jurusan: "IPS"
      }
    ],
    
    // Kursus
    courses: [
      {
        instruktur_lembaga: "Google Digital Marketing",
        tempat: "Online",
        lama_pendidikan: "2 bulan",
        yang_membiayai: "Perusahaan",
        keterangan: "Google Ads Certification"
      },
      {
        instruktur_lembaga: "Facebook Blueprint",
        tempat: "Online", 
        lama_pendidikan: "1 bulan",
        yang_membiayai: "Pribadi",
        keterangan: "Facebook Marketing Certification"
      }
    ],
    
    // Umum & Kesehatan
    generalHealth: {
      willing_original_certificate: 1,
      allow_contact_employer: 1,
      ever_fired: 0,
      decision_advice_source: "Friends",
      decision_advice_note: "Diskusi dengan teman seprofesi",
      personal_advice_source: "Keluarga",
      personal_advice_note: "Konsultasi dengan orang tua",
      reaction_to_criticism: "Menerima dengan terbuka dan belajar",
      common_illness: "Migrain ringan",
      serious_illness: 0,
      serious_illness_desc: "",
      eye_disease: 0,
      lung_disease: 0,
      ear_disease: 0,
      diabetes: 0,
      hypertension: 0,
      heart_disease: 0,
      last_checkup: "2024-12-15",
      strength: "Kreatif dan komunikatif",
      weakness: "Terlalu perfeksionis"
    },
    
    // Lain-lain
    others: {
      // Relasi saat berhalangan
      emergency_relations: [
        {
          nama: "Rina Sari",
          usia: 55,
          alamat: "Jl. Dago No. 45, Bandung",
          no_telepon: "081777888999",
          hubungan: "Ibu",
          keterangan: "Kontak utama"
        }
      ],
      
      // Eks atasan/keluarga
      former_relations: [
        {
          nama: "Indra Wijaya",
          usia: 42,
          alamat: "PT. Marketing Pro, Jl. Asia Afrika Bandung",
          no_telepon: "081222333444",
          hubungan: "Mantan Atasan",
          keterangan: "Marketing Director"
        }
      ],
      
      // Penjamin di PT Eureka
      guarantors: [
        {
          nama: "Maya Sari",
          usia: 35,
          alamat: "PT. Eureka Group, Jl. Gatot Subroto Jakarta",
          no_telepon: "081888999000",
          hubungan: "Teman Kuliah",
          keterangan: "Marketing Lead di PT. Eureka"
        }
      ]
    },
    
    applicationStatus: "Active",
    applicationDate: "2024-01-10",
    interviewDate: "2024-01-20",
    interviewStatus: "Completed"
  }
];

export default candidatesData;